export const MULTICINEMA = 'multi'
export const SINGLECINEMA = 'single'
export const MASTERMULTITOTAL = 'multiTotal'